var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c(
        "Button",
        {
          staticClass: "btn-light btn-sm border",
          nativeOn: {
            click: function ($event) {
              return _vm.onClick.apply(null, arguments)
            },
          },
        },
        [_vm._v("Login")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }